import "~/misc/common";
import { p } from "~/misc/common";
import Cookies from "js-cookie";
import { Calendar } from '@fullcalendar/core';

export function initCalDailyLimits(cal: Calendar) {
  p('initCalDailyLimits');

  const calendar = cal;

  // create button dynamically
  const btn = $('<button>', {
    class: 'btn btn-default btn-sm margin-5px',
    html: '<i class="fa fa-calendar-check-o"></i> Regisztrációk'
  });
  $('#btnContainer').append(btn);

  const source = calendar.addEventSource({
    url: '/daily_limits.json',
    extraParams: {
      'q[registered_gt]': 0,
      'q[launch_area_id_eq]': $('#q_launch_area_id_eq').val()
    }
  });
  source.remove();

  let active = !(Cookies.get('cal_no_daily_limits') == 'true');

  refresh();

  btn.on('click', function (e) {
    $(this).blur();
    active = !active;
    refresh();
  });

  function refresh() {
    active ? btn.css('background-color', '#def2d9') : btn.css('background-color', 'white');
    active ? calendar.addEventSource(source) : source.remove();
    Cookies.set('cal_no_daily_limits', !active + '', {
      expires: 10,
      path: '/'
    });
  }

}